import React from 'react';
import { Form, Button, Row, Col } from 'components';
import { BrandSelect } from 'components/common/brandSelect';
import { CloseIcon, DoneIcon } from 'components/common/icons';
import { useAccessControl } from '../../../../../components/common/accessControl/useAccessControl';
import { PERMISSIONS } from '../../../../../constants/permissions';

interface BrandSelectionProps {
  form: any;
  brandToAdd: string | undefined;
  setBrandToAdd: (value: string | undefined) => void;
  brandOptions: Array<any>;
  brandList: string[];
  setOpenBrandModal: (value: boolean) => void;
  onAddBrand: (brand: string) => void;
}

export const BrandSelection: React.FC<BrandSelectionProps> = ({
  form,
  brandToAdd,
  setBrandToAdd,
  brandOptions,
  brandList,
  setOpenBrandModal,
  onAddBrand,
}) => {
  const { hasAccess } = useAccessControl();
  return (
    <>
      <Form.Item
        name="brands"
        label="Brands*"
        validateTrigger={[]}
        rules={[
          {
            validator: (_) => {
              if (brandList.length === 0) {
                return Promise.reject(new Error('At least one brand must be selected.'));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <BrandSelect
          onChange={(i) => setBrandToAdd(i)}
          options={
            hasAccess(PERMISSIONS.brands.brand.read)
              ? brandOptions.map((i: any) => ({
                  ...i,
                  disabled: brandList.includes(i.value),
                }))
              : []
          }
          size="large"
          showAdd={hasAccess(PERMISSIONS.brands.brand.write)}
          onAdd={() => setOpenBrandModal(true)}
        />
      </Form.Item>
      <Col span={24} style={{ marginTop: 12, paddingRight: 0 }}>
        <Row gutter={4} justify={'end'}>
          <Col>
            <Button
              disabled={!brandToAdd}
              color="default"
              variant="filled"
              onClick={() => setBrandToAdd(undefined)}
              icon={<CloseIcon />}
            />
          </Col>
          <Col>
            <Button
              disabled={!brandToAdd}
              type={'primary'}
              icon={<DoneIcon />}
              onClick={() => {
                if (brandToAdd) {
                  onAddBrand(brandToAdd);
                  setBrandToAdd('');
                  form.setFieldValue('brands', '');
                }
              }}
            />
          </Col>
        </Row>
      </Col>
    </>
  );
};
